import React from 'react';
import PropTypes from 'prop-types';

// Section components
import Trending from '../Trending';
import LinkPiles from '../LinkPiles';
import Lyp from '../Lyp';
import Scratchpad from '../Scratchpad';

import './Content.less';

// Map of components
const componentsMap = {
  'hp-linkpile': LinkPiles,
  'hp-lyp': Lyp
};

const CNAME = 'Content';

const Content = ({ sections }) => (
  <main role="main">
    <article className={CNAME}>
      <Scratchpad />
      <Trending />
      {
        sections.map((section) => {
          const Component = componentsMap[section.id];
          return Component ?
            <section key={section.id} className={`${CNAME}__section`}>
              <Component {...section} />
            </section> : null;
        })
      }
    </article>
  </main>
);

Content.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.object)
};

export default Content;



// WEBPACK FOOTER //
// ./src/universal/components/Content/Content.js